// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import { VNumberInput } from 'vuetify/labs/VNumberInput'
// Vuetify
import { h } from 'vue'
import type { IconProps, IconSet } from 'vuetify'
import { createVuetify } from 'vuetify'
import { md2 } from 'vuetify/blueprints'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi'
import calendar from './assets/icons/calendar.vue'
import ecg from './assets/icons/ecg.vue'
import information from './assets/icons/information.vue'
import magnifier from './assets/icons/magnifier.vue'
import magnifierMenu from './assets/icons/magnifier-menu.vue'
import ai from './assets/icons/ai.vue'
import map from './assets/icons/map.vue'
import patient from './assets/icons/persons/patient.vue'
import practitioner from './assets/icons/persons/practitioner.vue'
import person from './assets/icons/persons/person.vue'
import careTeam from './assets/icons/persons/care-team.vue'
import settings from './assets/icons/settings.vue'
import settingsAlternative from './assets/icons/setting-alternative.vue'
import tune from './assets/icons/tune.vue'
import heartEvent from './assets/icons/events/heart-event.vue'
import lungsEvent from './assets/icons/events/lungs-event.vue'
import ecgEvent from './assets/icons/events/ecg-event.vue'
import document from './assets/icons/document.vue'
import equipement from './assets/icons/equipement.vue'
import network from './assets/icons/network.vue'
import planning from './assets/icons/planning.vue'
import record from './assets/icons/record.vue'
import microphoneoff from './assets/icons/microphone-off.vue'
import microphoneoutline from './assets/icons/microphone-outline.vue'
import videooffoutline from './assets/icons/video-off-outline.vue'
import videooutline from './assets/icons/video-outline.vue'
import pipbottomright from './assets/icons/picture-in-picture-bottom-right.vue'
import accountplus from './assets/icons/account-plus.vue'
import cameraflipoutline from './assets/icons/camera-flip-outline.vue'
import checkcircleoutline from './assets/icons/check-circle-outline.vue'
import female from './assets/icons/persons/female.vue'
import male from './assets/icons/persons/male.vue'
import refresh from './assets/icons/refresh.vue'
import stop from './assets/icons/stop.vue'
import camera from './assets/icons/contact/camera.vue'
import cameraAlternative from './assets/icons/contact/camera-alternative.vue'
import phonehangup from './assets/icons/contact/phone-hangup.vue'
import phone from './assets/icons/contact/phone.vue'
import phoneIncoming from './assets/icons/contact/phone-incoming.vue'
import phoneOutgoing from './assets/icons/contact/phone-outgoing.vue'
import mobileOutgoing from './assets/icons/contact/mobile-outgoing.vue'
import mobile from './assets/icons/contact/mobile.vue'
import chatText from './assets/icons/contact/chat-text.vue'
import watch from './assets/icons/contact/watch.vue'
import watchIncoming from './assets/icons/contact/watchIncoming.vue'
import time from './assets/icons/time.vue'
import crosshair from './assets/icons/crosshair.vue'

import mailOutgoing from './assets/icons/contact/mail-outgoing.vue'
import mail from './assets/icons/contact/mail.vue'
import home from './assets/icons/home.vue'
import anntag from './assets/icons/ann-tag.vue'
import door from './assets/icons/door.vue'
import note from './assets/icons/note.vue'
import virtualVisit from './assets/icons/contact/virtual-visit.vue'
import star from './assets/icons/star.vue'
import hospital from './assets/icons/hospital.vue'
import circleAssign from './assets/icons/circle-assign.vue'
import assign from './assets/icons/assign.vue'
import checkTask from './assets/icons/check-task.vue'
import circleProgress from './assets/icons/circle-progress.vue'
import messageBubbles from './assets/icons/contact/message-bubbles.vue'
import planningList from './assets/icons/planning-list.vue'
import addressTemp from './assets/icons/contact/address.vue'
import siren from './assets/icons/siren.vue'
import clock from './assets/icons/clock.vue'
import warning from './assets/icons/warning.vue'
import calendarOutline from './assets/icons/calendar-outline.vue'
import syringe from './assets/icons/syringe.vue'
import medicalVisitation from './assets/icons/medical-visitation.vue'
import telexpertice from './assets/icons/telexpertice.vue'
import eye from './assets/icons/eye.vue'
import mailSecured from './assets/icons/contact/mail-secured.vue'
import mailIncoming from './assets/icons/contact/main-incoming.vue'
import mailSecuredIncoming from './assets/icons/contact/main-secured-incoming.vue'
import cancelledPhone from './assets/icons/contact/cancelled/cancelledPhone.vue'
import cancelledMailOutgoing from './assets/icons/contact/cancelled/cancelledMailOutgoing.vue'
import cancelledCamera from './assets/icons/contact/cancelled/cancelledCamera.vue'
import cancelledHome from './assets/icons/contact/cancelled/cancelledHome.vue'
import cancelledTelexpertice from './assets/icons/contact/cancelled/cancelledTelexpertice.vue'
import cancelledMedicalVisitation from './assets/icons/contact/cancelled/cancelledMedicalVisitation.vue'
import cancelledVirtualVisit from './assets/icons/contact/cancelled/cancelledVirtualVisit.vue'
import loginKey from './assets/icons/login/key.vue'
import loginUser from './assets/icons/login/user.vue'
import loginLock from './assets/icons/login/lock.vue'
import sendMessage from './assets/icons/send-message.vue'
import signIn from './assets/icons/login/sign-in.vue'
import info from './assets/icons/login/info.vue'
import linkIcon from './assets/icons/login/link.vue'
import severityLevel from './assets/icons/severity-level.vue'
import severityWarning from './assets/icons/severity-level-warning.vue'
import severityNote from './assets/icons/severity-level-note.vue'
import severityAttention from './assets/icons/severity-level-attention.vue'
import severityPrimary from './assets/icons/severity-level-primary.vue'
import deceasedTag from './assets/icons/deceased-tag.vue'
import collapseSidebar from './assets/icons/collapse-sidebar.vue'
import practitionerFilterSearch from './assets/icons/practitioner-filter-search.vue'
import practitionerVerified from './assets/icons/practitioner-verified.vue'
import practitionerStethoscope from './assets/icons/practitioner-stethoscope.vue'
import rpps from './assets/icons/rpps.vue'
import asclepius from './assets/icons/asclepius.vue'
import notepad from './assets/icons/notepad.vue'
import folder from './assets/icons/folder.vue'
import file from './assets/icons/file.vue'
import users from './assets/icons/users.vue'
import mapTriFold from './assets/icons/mapTriFold.vue'
import userSquare from './assets/icons/user-square.vue'
import clockFullCircle from './assets/icons/clock-full-circle.vue'
import alert from './assets/icons/alert.vue'
import planningSidePannelClose from './assets/icons/planning-side-pannel-close.vue'
import radioSelected from './assets/icons/radio-selected.vue'
import radioUnSelected from './assets/icons/radio-unselected.vue'
import smsSent from './assets/icons/sms-sent.vue'
import smsFail from './assets/icons/sms-fail.vue'

const svgToComponent: any = {
  ecg,
  anntag,
  calendar,
  calendarOutline,
  tune,
  settings,
  settingsAlternative,
  patient,
  practitioner,
  person,
  careTeam,
  camera,
  cameraAlternative,
  map,
  information,
  magnifier,
  magnifierMenu,
  ai,
  heartEvent,
  lungsEvent,
  ecgEvent,
  crosshair,
  document,
  equipement,
  network,
  planning,
  record,
  microphoneoff,
  microphoneoutline,
  videooffoutline,
  videooutline,
  pipbottomright,
  accountplus,
  cameraflipoutline,
  phonehangup,
  checkcircleoutline,
  female,
  male,
  refresh,
  stop,
  phone,
  phoneIncoming,
  phoneOutgoing,
  mobileOutgoing,
  mobile,
  watch,
  watchIncoming,
  chatText,
  mailOutgoing,
  mail,
  home,
  door,
  note,
  virtualVisit,
  star,
  siren,
  hospital,
  circleAssign,
  circleProgress,
  messageBubbles,
  planningList,
  addressTemp,
  clock,
  warning,
  syringe,
  medicalVisitation,
  telexpertice,
  eye,
  assign,
  checkTask,
  mailSecured,
  mailIncoming,
  mailSecuredIncoming,
  cancelledPhone,
  cancelledMailOutgoing,
  cancelledCamera,
  cancelledHome,
  cancelledTelexpertice,
  cancelledMedicalVisitation,
  cancelledVirtualVisit,
  loginKey,
  loginUser,
  loginLock,
  sendMessage,
  signIn,
  info,
  time,
  linkIcon,
  severityLevel,
  severityWarning,
  severityNote,
  severityAttention,
  severityPrimary,
  deceasedTag,
  collapseSidebar,
  practitionerFilterSearch,
  practitionerVerified,
  practitionerStethoscope,
  rpps,
  asclepius,
  notepad,
  folder,
  file,
  users,
  mapTriFold,
  userSquare,
  clockFullCircle,
  alert,
  planningSidePannelClose,
  radioSelected,
  radioUnSelected,
  smsSent,
  smsFail,
}

const epocaIcon: IconSet = {
  component: (props: IconProps) => h(svgToComponent[props.icon]),
}

export const light = {
  dark: false,
  colors: {
    primary: '#194355',
    'on-primary': '#FFFFFF',
    secondary: '#9Bff90',
    info: '#ffbf42',
    warning: '#ff8042',
    error: '#ff425f',
    accent: '#42b1ff',
    success: '#009b8c',
    grey1: '#eee',
    grey2: '#bbb',
    grey3: '#333',
  },
}

export const dark = {
  dark: true,
}

const messages = {
  fr: {
    open: 'Ouvrir',
    close: 'Fermer',
    input: {
      clear: 'effacer',
    },
    datePicker: { title: 'Sélectionner une date' },
  },
}

export const locale = {
  locale: 'fr',
  messages,
}

export const vuetify: any = createVuetify({
  components: {
    ...components,
    VDateInput,
    VTimePicker,
    VNumberInput,
  },
  defaults: {
    VTooltip: {
      eager: false,
    },
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: light,
      dark: dark,
    },
  },
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
      epoca: epocaIcon,
    },
  },
  locale: locale,
})
